export default __webpack_public_path__ + "static/media/connectyourcare-logo.2def1e2f.png";